import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import type { IQuestion } from '../questions';
import { Campaign } from './campaign';
import type { CampaignClass, ICampaignAttributes } from './types';

export interface IConversationCampaignTheme {
  palette: {
    primary1Color: string;
    accent1Color: string;
  };
}

export type TConversationCampaign = ICampaignAttributes & {
  readonly _cls: CampaignClass.Conversation;
  questions: IQuestion[];
  logo: string;
  theme: IConversationCampaignTheme;
  thumbnail_url: string;
  url: string;
};

export class ConversationCampaign extends Campaign<TConversationCampaign> {
  public override get constraints(): TConstraints<TConversationCampaign> {
    return {
      // ...super.constraints,
      url: {
        presence: {
          allowEmpty: false,
        },
        search: {
          pattern: /^[^*]*$/,
          message: 'must not contain *',
        },
      },
    };
  }

  constructor(attributes: Partial<TConversationCampaign> = {}) {
    super(attributes);

    makeObservable(this);
  }

  public override getDefaults(): Partial<TConversationCampaign> {
    return {
      ...super.getDefaults(),
      url: '',
    };
  }

  public override get name(): string {
    const customName = this.get('name')?.trim() ?? '';
    const firstQuestionText = this.get('questions')[0]?.text?.trim();

    if (customName) {
      return customName;
    }

    if (firstQuestionText) {
      return firstQuestionText;
    }

    return 'Unnamed Conversation Campaign';
  }
}
